<div class="fb-container kenjo-row kenjo-justify-center kenjo-mb-30px kenjo-pt-20px" [ngClass]="{'fb-progress-one': (currentProgress$ | async) > 0}" >
  <div class="kenjo-font-size-16px kenjo-mr-5px kenjo-hide-on-mobile-landscape">{{ 'poweredBy' | translate }}</div>
  <img class="kenjo-hide-on-mobile-landscape" src="/assets/images/horizontal-logo.svg" width="90px"/>
</div>

<div class="fb-responsive-space"></div>
